import EventViewCoordinators from './EventViewCoordinators';

export default EventViewCoordinators;
